export const LIVENESS_BLINK_TARGET = 1;

export const LIVENESS_BLINK_REFRACTORY_MS = 400;

export const LIVENESS_STEP_TIMEOUT_MS = 12000;

export const LIVENESS_STEP_HINT_AFTER_MS = 6000;
